<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()" (deleteClick)="onDeleteClicked()">
  <app-invoice-payment-form *ngIf="value"
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-invoice-payment-form>
</app-base-entry-dialog-template>
